import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=1d0ae809&scoped=true&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ae809",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0ae809')) {
      api.createRecord('1d0ae809', component.options)
    } else {
      api.reload('1d0ae809', component.options)
    }
    module.hot.accept("./CardFooter.vue?vue&type=template&id=1d0ae809&scoped=true&", function () {
      api.rerender('1d0ae809', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/card/CardFooter.vue"
export default component.exports